import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import SubRouteAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route.entity';
import RouteAttributes from '@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity';
import { RouteInfo } from 'app/modules/components/routing/sub-routes/client-route-locator/interfaces/client-route-locator.interface';
import { RouteAreaModal } from 'app/modules/components/modals/dto/routes-detail-by-businesss-partnert-vehicle-dto';
import { SubRouteNavigationComponent } from 'app/shared/components/sub-route-navigation/sub-route-navigation.component';
import { RouteNavigationComponent } from 'app/shared/components/route-navigation/route-navigation.component';
import { SalesOfficeNavigationComponent } from 'app/shared/components/sales-office-navigation/sales-office-navigation.component';
import { BusinessPartnerNavigationComponent } from 'app/shared/components/business-partner-navigation/business-partner-navigation.component';

export interface VehicleRoutesModalData {
  subRoutes: SubRouteAttributes[];
  vehicleName: string;
}

@Component({
  selector: 'app-vehicle-routes-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    SubRouteNavigationComponent,
    RouteNavigationComponent,
    SalesOfficeNavigationComponent,
    BusinessPartnerNavigationComponent
  ],
  templateUrl: './vehicle-routes-modal.component.html',
  styleUrl: './vehicle-routes-modal.component.scss'
})
export class VehicleRoutesModalComponent {
  protected readonly data = inject<VehicleRoutesModalData>(MAT_DIALOG_DATA);

  readonly displayedColumns = ['route', 'territory', 'saleOffice', 'assignedUser'];
  dataSource: RouteAreaModal[] = [];

  constructor() {
    this.processSubRoutes();
  }

  private processSubRoutes(): void {
    const subRoutes = this.data.subRoutes ?? [];

    this.dataSource = subRoutes.map((subRoute: SubRouteAttributes) => {
      const routes: RouteInfo[] = (subRoute.routes ?? []).map((route: RouteAttributes) => ({
        _id: route._id?.toString() ?? '',
        id: route.id,
        name: route.name,
        statusId: route.statusId,
        externalKeys: route.externalKeys
      }));

      return {
        _id: subRoute._id?.toString() ?? '',
        id: 0,
        nameSubRoute: subRoute.name,
        salesOffice: subRoute.salesOffice?.name ?? '',
        assignedUser: subRoute.responsibleBusinessPartner?.name ?? '',
        salesOfficeCode: subRoute.salesOffice?.externalKeys?.code ?? '',
        assignedUserCode: subRoute.responsibleBusinessPartner?.externalKeys?.code ?? '',
        subRouteCode: subRoute.externalKeys?.code ?? '',
        routes
      };
    });
  }

  /** Max territory chips shown inline before collapsing into a "+N" chip. */
  private readonly MAX_VISIBLE_TERRITORIES = 2;

  getTerritoriesRoutes(element: RouteAreaModal): RouteInfo[] {
    return element.routes ?? [];
  }

  /** First N territories shown as chips; the rest collapse into a "+N" chip. */
  visibleTerritories(element: RouteAreaModal): RouteInfo[] {
    return this.getTerritoriesRoutes(element).slice(0, this.MAX_VISIBLE_TERRITORIES);
  }

  hiddenTerritoriesCount(element: RouteAreaModal): number {
    return Math.max(0, this.getTerritoriesRoutes(element).length - this.MAX_VISIBLE_TERRITORIES);
  }
}
